<template>
  <div class="page_trendChart">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>结算</el-breadcrumb-item>
          <el-breadcrumb-item>银行余额</el-breadcrumb-item>
          <el-breadcrumb-item>现金流量趋势图</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-form :inline="true" class="re_down_form" label-width="98px">
            <el-form-item label="账户名称" size="small">
              <el-select v-model="accountName" size="small" @change="changeAccountName" filterable clearable placeholder="" style="width: 180px;">
                <el-option v-for="(item, index) in accountNameList" :key="index" :value="item.accountName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="账号" size="small">
              <el-select v-model="cardId" size="small" @change="getList" filterable clearable placeholder="" style="width: 180px;">
                <el-option v-for="(item, index) in accountList" :key="index" :label="item.accountNo" :value="item.accountNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间范围" size="small">
              <el-select v-model="period" size="small" @change="getList" filterable clearable placeholder="" style="width: 180px;">
                <el-option label="近一个月" value="month">
                </el-option>
                <el-option label="近三个月" value="quarter">
                </el-option>
                <el-option label="近一年" value="year">
                </el-option>
                <el-option label="近三年" value="threeYears">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-button type="primary" size="small" @click="getList">查询</el-button>
          <el-button type="primary" size="small" @click="downChart">下载</el-button>
        </div>
        <div ref="myChart" style="width: 1000px;height:435px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import * as echarts from 'echarts';
  import 'echarts/lib/chart/line';
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        accountName: '',
        cardId: '',
        period: 'month', //month|quarter|year|threeYears
        accountNameList: [], //账号名称列表
        accountList: [], //账号列表
        xAxisData: [],
        yAxisData: [],
      }
    },
    created() {},
    mounted() {
      this.GetBankAccountNamePageList();
      this.getList();
      this.initChart();
    },
    methods: {
      GetBankAccountNamePageList() {
        let d = {
          pageNumber: 1,
          pageSize: 10000,
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype
        }
        xz.ArdCurStat(d, 'GetBankAccountNamePageList').then(res => {
          if (res.status == 'ok') {
            this.accountNameList = res.data.dataList;
          } else {
            this.accountNameList = [];
          }
        })
      },
      changeAccountName() {
        let d = {
          pageModel: {
            rows: 1000,
            page: 1,
            orderInput: [],
          },
          accountName: this.accountName,
          accountNo: ""
        }
        xz.ArdCurStat(d, 'GetBankStataAcountNameOpenBankPageList1').then(res => {
          if (res.status == 'ok') {
            this.accountList = res.data.data;
          } else {
            this.accountList = [];
          }
        })
      },
      getList() {
        let str = `?cardId=${this.cardId}&period=${this.period}`
        xz.ArdCurStatGetFun('GetBalanceChartData', str).then(res => {
          if (res.status == 'ok') {
            this.yAxisData = res.data.data;
            this.xAxisData = res.data.labels;
            this.initChart();
          } else {
            this.yAxisData = [];
            this.xAxisData = [];
            this.$message.error(res.message);
          }
        })
      },
      initChart() {
        var myChart = echarts.init(this.$refs.myChart);
        var option = {
          // ECharts的配置项
          title: {
            text: '现金流量趋势图'
          },
          tooltip: {},
          xAxis: {
            data: this.xAxisData
          },
          yAxis: {
            // type: 'value',
            // axisLabel: {
            //   formatter: '{value} 万 RMB'
            // }
            name: '人民币（万）',
            type: 'value',
          },
          series: [{
            name: '人民币（万）',
            type: 'line', // 这里使用线状图类型
            smooth: true,
            data: this.yAxisData
          }]
        };
        myChart.setOption(option);
      },
      downChart() {
        var myChart = echarts.init(this.$refs.myChart);
        const imgUrl = myChart.getDataURL({
          pixelRatio: 2, // 导出的图片分辨率比例，默认为1，可以根据需要调整
          backgroundColor: '#fff' // 导出的图片背景色，默认为透明背景（'transparent'）
        });

        // 使用imgUrl创建一个图片并显示或者下载
        const link = document.createElement('a');
        link.href = imgUrl;
        link.download = `${this.accountName}现金流量趋势图.png`; // 设置下载的文件名
        link.click(); // 触发点击事件以开始下载
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }
</style>
<style>
  .page_trendChart .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_trendChart .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_trendChart .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_trendChart .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_trendChart .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_trendChart .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_trendChart .ftabBtn .el-form-item {
    margin-bottom: 0;
  }
</style>